<div class="contact-box-wrapper">
  <div class="contact-phone-dropdowns">
    <label>{{ 'searchContact.nameType' | xTranslate }}</label>
  </div>
  <mat-form-field appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      class="select add-contact-dropdown"
      [value]="selectedName"
      [placeholder]="selectedName"
      (selectionChange)="nameSelection($event)"
    >
      <mat-option [ngClass]="'select-option'" *ngFor="let item of nameCatalog" [value]="item.value">
        {{ item.label | uppercase }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="contact-phone-dropdowns">
    <label>{{ 'searchContact.phoneType' | xTranslate }}</label>
  </div>
  <mat-form-field appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      class="select add-contact-dropdown"
      [value]="selectedPhone"
      [placeholder]="selectedPhone"
      (selectionChange)="phoneSelection($event)"
    >
      <mat-option [ngClass]="'select-option'" *ngFor="let item of phoneCatalog" [value]="item.value">
        {{ item.label | uppercase }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
